'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
import * as SettingsCategories from 'DesignData/enums/settings/Categories';
/**
 * High level option parameters that for an active editor.
 * For example, an active sub-editor.
 *
 * @typedef {Object} EditorOptions
 * @property {SettingsCategories} settingsCategory - Active settings category in settings editor.
 */

export default class EditorOptions extends ImmutableModel {
  constructor(props) {
    props = props || {}; // Validate settingsCategory if passed.

    if (props.settingsCategory && !(props.settingsCategory in SettingsCategories)) {
      throw new TypeError(`settingsCategory is invalid, received "${props.settingsCategory}"`);
    }

    return super(props);
  }

}
EditorOptions.DEFAULT_FIELDS = Object.freeze({
  /**
   * @type {Number}
   */
  revisionId: undefined,

  /**
   * @type {enums/settings/Categories}
   * Used to determine category when `assetType == DesignAssetTypes.SETTINGS`
   */
  settingsCategory: SettingsCategories.NONE,

  /**
   * @type {enums/AssetSources}
   * Determines which APIs needed and how to identify.
   */
  assetSource: null,

  /**
   * @type {Boolean}
   * Indicates if query param show_compiled_output is in URL
   */
  showCompiledOutput: false
});
EditorOptions.EMPTY = new EditorOptions();